import axios from 'axios'
import moment from 'moment'
import APIConfig from '../remote/APIConfig.js'

export default class AdministartorService {
  constructor (passwordCrypter) {
    this.passwordCrypter = passwordCrypter
    this.apis = {
      getMe: () => axios.get(APIConfig.BPIURL + '/me'),
      updateMe: (payload) => axios.put(APIConfig.BPIURL + '/me', payload),
      updatePassword: (payload) => axios.put(APIConfig.BPIURL + '/me/password', payload)
    }
  }

  hasValidFBToken (vm) {
    var result = false
    try {
      let expiredAt = vm.$store.state.admin.Profile.FbTokenExpiredAt
      if (expiredAt) {
        result = moment(expiredAt).unix() * 1000 > new Date().getTime()
      }
    } catch (err) {
      console.error(err)
    }
    return result
  }
  hasValidIGToken (vm) {
    var result = false
    try {
      let expiredAt = vm.$store.state.admin.Profile.IgTokenExpiredAt
      if (expiredAt) {
        result = moment(expiredAt).unix() * 1000 > new Date().getTime()
      }
    } catch (err) {
      console.error(err)
    }
    return result
  }

  getMe (vm) {
    vm.isLoading = true
    return this.apis.getMe()
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        try {
          if (!ok) {
            vm.$services.alertResultError(vm, res)
          }
        } catch (err) {
          console.error(err)
        }
        return res
      })
      .catch(err => {
        vm.$services.alertError(vm, err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  updateMe (vm, payload) {
    vm.isLoading = true
    return this.apis.updateMe(payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        try {
          if (ok) {
            vm.$set(vm.$store.state.admin.Profile, 'Name', payload.Name)
          }
          if (!ok) {
            vm.$services.alertResultError(vm, res)
          }
        } catch (err) {
          console.error(err)
        }
        return res
      })
      .catch(err => {
        vm.$services.alertError(vm, err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  updatePassword (vm, payload) {
    vm.isLoading = true
    payload.Password = this.passwordCrypter.cryptPassword(payload.Password)
    payload.NewPassword = this.passwordCrypter.cryptPassword(payload.NewPassword)
    return this.apis.updatePassword(payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        try {
          if (!ok) {
            vm.$services.alertResultError(vm, res)
          }
        } catch (err) {
          console.error(err)
        }
        return res
      })
      .catch(err => {
        vm.$services.alertError(vm, err)
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}
